export const zIndices = {
    hide: '-1',
    auto: 'auto',
    base: '0',
    tableColumnHeader: '1',
    pinnedTableRowHeader: '1',
    pinnedTableColumnHeader: '2',
    contentOverlay: '100',
    navOverlay: '200',
    dropdown: '1000',
    overlay: '1300',
    modal: '1400',
    popover: '1500',
    toast: '1700',
    tooltip: '1800',
};
//# sourceMappingURL=z-index.js.map